import React, {useEffect, useState} from 'react';
import {Box, Typography, ScrollMarquee} from '@ttx/design-system';
import {
  CountdownInfoProps,
  formatCountdownString,
  getCountdownInfo,
} from '../../pages/artists/utils';

interface ScrollMarqueeCountdownProps {
  artistName?: string | null;
  collectionName: string;
  nextDropDate: Date | null;
}

export const ScrollMarqueeCountdown: React.FC<ScrollMarqueeCountdownProps> = ({
  artistName,
  collectionName,
  nextDropDate,
}) => {
  const [countdownComplete, setCountdownComplete] = useState<boolean>(false);
  const [countdownInfo, setCountdownInfo] = useState<CountdownInfoProps>();

  useEffect(() => {
    if (!nextDropDate) return;
    setCountdownInfo(getCountdownInfo(nextDropDate));
  }, [nextDropDate]);

  useEffect(() => {
    if (!nextDropDate || !countdownInfo) return;
    if (
      countdownInfo.days +
        countdownInfo.hours +
        countdownInfo.minutes +
        countdownInfo.seconds <=
      0
    ) {
      setCountdownComplete(true);
    } else {
      const countdownInterval = setInterval(() => {
        setCountdownInfo(getCountdownInfo(nextDropDate));
      }, 1000);
      // eslint-disable-next-line consistent-return
      return () => clearInterval(countdownInterval);
    }
  }, [countdownInfo, nextDropDate]);

  if (!countdownInfo)
    return (
      <ScrollMarquee play speed={130} gradient={false}>
        <Box paddingY={['md', 'five']} width="100%" flexDirection="row">
          <Typography
            color="textDefault"
            textStyle={['h1']}
            css={{
              'white-space': 'nowrap',
            }}
          >
            {`${artistName}: Coming Soon! — ${artistName}: Coming Soon! —  ${artistName}: Coming Soon! —`}
          </Typography>
        </Box>
      </ScrollMarquee>
    );

  return (
    <ScrollMarquee play speed={130} gradient={false}>
      <Box paddingY={['md', 'five']} width="100%" flexDirection="row">
        {!countdownComplete ? (
          <>
            <Typography
              color="textDefault"
              textStyle={['h1']}
              css={{
                'white-space': 'nowrap',
              }}
            >
              {formatCountdownString(countdownInfo)}
            </Typography>
            <Box
              paddingX="four"
              width="105px"
              justifyContent="center"
              alignItems="center"
            >
              <Typography
                color="textDefault"
                textStyle={['h1']}
                css={{
                  'white-space': 'nowrap',
                }}
              >
                {countdownInfo.seconds.toString()}
              </Typography>
            </Box>
            <Typography
              color="textDefault"
              textStyle={['h1']}
              css={{
                'white-space': 'nowrap',
              }}
            >
              {`second${countdownInfo.seconds !== 1 ? 's' : ''} —`}
            </Typography>
          </>
        ) : (
          <Typography
            color="textDefault"
            textStyle={['h1']}
            css={{
              'white-space': 'nowrap',
            }}
          >
            {`${artistName}: ${collectionName} Now Live! — ${artistName}: ${collectionName} Now Live! —`}
          </Typography>
        )}
      </Box>
    </ScrollMarquee>
  );
};
